module.exports = __webpack_public_path__ + "static/media/FlowerAILogoWhite.3c67be01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo/FlowerAILogoWhite.svg
// module id = 542
// module chunks = 0